export default __webpack_public_path__ + "locales/pt/PrivacyPage.json?hash=87889371e2bf6bb6ba44a9a324fd49b4";